import { ref, computed } from '@vue/composition-api'

export const KnowledgeSearchOrderSetting = (props, context) => {
  const store = context.root.$store
  const { knowledge } = store.state
  const radioModel = ref(knowledge.search.ascending)
  const isSearch = computed(() => store.getters['knowledge/isSearch'] && knowledge.search.keyword !== '')
  // 検索時以外は関連度順で検索させない
  if (!isSearch.value && radioModel.value === 'score') {
    radioModel.value = 'created_desc'
  }

  const close = () => {
    context.emit('closeKnowledgeSearchOrderSetting')
  }
  const submit = () => {
    store.dispatch('knowledge/setSearchOption', { ascending: radioModel.value })

    // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用IDをクリア
    store.dispatch('knowledge/setSelectedListItemId', 0)

    context.emit('submit')
    close()
  }

  return {
    radioModel,
    close,
    submit,
    knowledge,
    isSearch
  }
}
